<template>
  <div class="home-mobile-container">
    <!-- 内容滚动区域 -->
    <div class="main-scroll-content">
      <!-- 轮播图 Banner (优化为 3:2 横屏铺满与底部标题蒙层) -->
      <div class="banner-section">
        <el-carousel indicator-position="outside" height="160px" autoplay>
          <el-carousel-item v-for="item in bannerList" :key="item.videoId">
            <div class="banner-item" @click="handleBannerClick(item)">
              <img :src="item.coverUrl" class="banner-img" alt="cover">
              <div class="banner-mask">
                <h3 class="banner-title">{{ item.title }}</h3>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 分类 Tab 切换 -->
      <div class="category-tabs">
        <div
          v-for="tab in categoryTabs"
          :key="tab.value"
          class="tab-item"
          :class="{ active: currentCategory === tab.value }"
          @click="changeCategory(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>

      <!-- 视频双列网格列表 -->
      <div class="video-grid">
        <div
          v-for="(item, index) in filteredVideoList"
          :key="item.videoId + '_' + index"
          class="video-card"
          @click="openVideoDetail(item)"
        >
          <div class="cover-wrapper">
            <img :src="item.coverUrl" class="video-cover" alt="cover">

            <!-- 仅保留 Icon 的横竖屏标识 -->
            <span class="orientation-tag">
              <i :class="item.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
            </span>

            <span v-if="item.duration" class="duration-tag">{{ item.duration }}</span>
          </div>

          <div class="video-info">
            <h4 class="title">{{ item.title }}</h4>
            <div class="user-info">
              <div class="author-detail">
                <img :src="item.user && item.user.avatarUrl" class="avatar" alt="avatar">
                <span class="username">{{ item.user ? item.user.screenName : '匿名用户' }}</span>
              </div>
              <div class="more-btn" @click.stop="openMoreDialog(item)">
                <i class="el-icon-more" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态与底线提示 -->
      <div class="load-status-bar">
        <div v-if="loading" class="loading-wrap">
          <i class="el-icon-loading" />
          <span>正在加载更多精彩内容...</span>
        </div>
        <div v-else-if="finished" class="no-more-wrap">
          <span>— 没有更多视频了 —</span>
        </div>
      </div>
    </div>

    <!-- 底部弹出的 Dialog 选项弹窗 -->
    <el-dialog
      :visible.sync="showMoreDialog"
      width="100%"
      custom-class="bottom-action-dialog"
      :show-close="false"
      append-to-body
    >
      <div v-if="activeVideoItem" class="dialog-action-content">
        <div class="drag-bar-wrap">
          <div class="drag-bar"></div>
        </div>

        <!-- 稍后再看卡片 -->
        <div class="action-card-row" @click="handleAction('watch-later')">
          <i class="el-icon-video-play" />
          <span>添加至稍后再看</span>
        </div>

        <!-- 我不想看区域 -->
        <div class="dislike-section">
          <div class="dislike-title">
            我不想看 <span class="sub-tip">(选择后将减少相似内容推荐)</span>
          </div>
          <div class="dislike-grid">
            <div class="dislike-tag" @click="handleAction('not-interested', 'UP主')">
              UP主：{{ activeVideoItem.user ? activeVideoItem.user.screenName : '未知UP主' }}
            </div>
            <div class="dislike-tag" @click="handleAction('not-interested', '频道-1')">
              频道：SpaceX
            </div>
            <div class="dislike-tag" @click="handleAction('not-interested', '频道-2')">
              频道：马斯克
            </div>
            <div class="dislike-tag" @click="handleAction('not-interested', '过多')">
              此类内容过多
            </div>
            <div class="dislike-tag" @click="handleAction('not-interested', '推荐过')">
              推荐过
            </div>
            <div class="dislike-tag" @click="handleAction('not-interested', '当前内容')">
              这个内容
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBannerVideo, videoRecommend } from '@/api/vod'

export default {
  name: 'HomeMobile',
  data() {
    return {
      currentCategory: 'rcmd',
      categoryTabs: [
        { label: '推荐', value: 'rcmd' },
        { label: '直播', value: 'live' }
      ],
      bannerList: [],
      videoList: [],
      nextId: 0,
      loading: false,
      finished: false,
      scrollContainer: null,
      showMoreDialog: false,
      activeVideoItem: null
    }
  },
  computed: {
    filteredVideoList() {
      if (this.currentCategory === 'rcmd') {
        return this.videoList
      }
      return this.videoList.filter(item => item.category === this.currentCategory)
    }
  },
  created() {
    this.getData()
    this.fetchVideoData()
  },
  mounted() {
    this.scrollContainer = document.getElementById('app') || window
    this.scrollContainer.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    getData() {
      getBannerVideo().then(resp => {
        if (resp.code === 0) {
          this.bannerList = resp.data
        }
      })
    },
    fetchVideoData() {
      if (this.loading || this.finished) return

      this.loading = true
      videoRecommend(this.nextId)
        .then(resp => {
          if (resp.code === 0) {
            const list = resp.data || []
            if (list.length === 0) {
              this.finished = true
            } else {
              this.videoList = [...this.videoList, ...list]
            }
          } else {
            this.$message.warning((resp && resp.msg) || '加载视频失败')
          }
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleScroll() {
      if (this.loading || this.finished) return

      let scrollTop = 0
      let scrollHeight = 0
      let clientHeight = 0

      if (this.scrollContainer === window) {
        scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        clientHeight = window.innerHeight
      } else {
        scrollTop = this.scrollContainer.scrollTop
        scrollHeight = this.scrollContainer.scrollHeight
        clientHeight = this.scrollContainer.clientHeight
      }

      if (scrollHeight - scrollTop - clientHeight < 200) {
        this.fetchVideoData()
      }
    },
    changeCategory(val) {
      this.currentCategory = val
    },
    openMoreDialog(item) {
      this.activeVideoItem = item
      this.showMoreDialog = true
    },
    handleAction(actionType) {
      if (actionType === 'watch-later') {
        this.$message.success(`稍后再看`)
      } else if (actionType === 'not-interested') {
        this.$message.info('已为您减少此类推荐')
      }
      this.showMoreDialog = false
    },
    handleBannerClick(item) {
      this.$router.push({ path: '/video/' + item.videoId })
    },
    openVideoDetail(item) {
      this.$router.push({ path: '/video/' + item.videoId })
    }
  }
}
</script>

<style scoped lang="scss">
.home-mobile-container {
  width: 100%;
}

.main-scroll-content {
  padding: 12px;
}

.banner-section {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;

  .banner-item {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: #000;

    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover; // 铺满整个 el-carousel-item
    }

    .banner-mask {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 24px 12px 10px 12px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, transparent 100%);
      pointer-events: none;

      .banner-title {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.category-tabs {
  display: flex;
  background-color: #ffffff;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow-x: auto;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

  &::-webkit-scrollbar {
    display: none;
  }

  .tab-item {
    padding: 6px 14px;
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
    border-radius: 16px;
    cursor: pointer;
    margin-right: 8px;
    transition: all 0.3s;

    &.active {
      background-color: #409eff;
      color: #ffffff;
      font-weight: bold;
    }
  }
}

.video-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .video-card {
    width: 48.5%;
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    cursor: pointer;

    .cover-wrapper {
      position: relative;
      width: 100%;
      padding-top: 66.66%; // 3:2 横屏比例
      background-color: #f0f2f5;

      .video-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /* 纯 Icon 样式 */
      .orientation-tag {
        position: absolute;
        top: 6px;
        left: 6px;
        background-color: rgba(0, 0, 0, 0.6);
        color: #ffffff;
        font-size: 12px;
        width: 22px;
        height: 22px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(2px);

        i {
          font-size: 13px;
        }
      }

      .duration-tag {
        position: absolute;
        bottom: 6px;
        right: 6px;
        background-color: rgba(0, 0, 0, 0.7);
        color: #ffffff;
        font-size: 10px;
        padding: 2px 5px;
        border-radius: 3px;
      }
    }

    .video-info {
      padding: 8px 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;

      .title {
        font-size: 13px;
        font-weight: 500;
        color: #303133;
        margin: 0 0 8px 0;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: pre-wrap;
      }

      .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        color: #909399;

        .author-detail {
          display: flex;
          align-items: center;
          overflow: hidden;
          max-width: 75%;

          .avatar {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            object-fit: cover;
            flex-shrink: 0;
          }

          .username {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .more-btn {
          padding: 2px 4px;
          cursor: pointer;
          color: #909399;

          i {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.load-status-bar {
  text-align: center;
  padding: 15px 0 25px;
  font-size: 13px;
  color: #909399;

  .loading-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    i {
      font-size: 16px;
    }
  }

  .no-more-wrap {
    color: #c0c4cc;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.bottom-action-dialog {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  background-color: #f4f5f7 !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .dialog-action-content {
    display: flex;
    flex-direction: column;
    padding: 6px 16px 24px 16px;

    .drag-bar-wrap {
      display: flex;
      justify-content: center;
      padding: 8px 0 12px 0;

      .drag-bar {
        width: 36px;
        height: 4px;
        background-color: #dcdfe6;
        border-radius: 2px;
      }
    }

    /* 稍后再看大卡片 */
    .action-card-row {
      display: flex;
      align-items: center;
      background-color: #ffffff;
      padding: 16px;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 16px;
      cursor: pointer;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);

      i {
        font-size: 20px;
        margin-right: 10px;
        color: #606266;
      }

      &:active {
        background-color: #f9fafb;
      }
    }

    /* 我不想看板块 */
    .dislike-section {
      .dislike-title {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 10px;

        .sub-tip {
          font-size: 12px;
          font-weight: normal;
          color: #909399;
          margin-left: 4px;
        }
      }

      .dislike-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .dislike-tag {
          width: calc(50% - 5px);
          background-color: #ffffff;
          padding: 13px 10px;
          border-radius: 8px;
          font-size: 13px;
          color: #303133;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);

          &:active {
            background-color: #f0f2f5;
          }
        }
      }
    }
  }
}
</style>
